import type { SVGProps } from "react";

/** Minne's logo mark (public/mark.svg); the stroke follows the text colour. Size it with `size-*`. */
export function Mark(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 100 100"
      fill="none"
      stroke="currentColor"
      strokeWidth={11}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      <path d="M32 74 Q24 74 24 65 V34 Q24 24 32 31 L50 50 L68 31 Q76 24 76 34 V65 Q76 74 68 74" />
    </svg>
  );
}
